import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface Props {
    children: ReactNode;
    isSideBarOpen?: boolean;
    hasMobileListingBottomBar?: boolean;
}

export const MapSize = ({children, isSideBarOpen, hasMobileListingBottomBar}: Props) => {
    return (
        <div className={cx(mapSizeStyle, isSideBarOpen && mapSizeWitchSidebar, hasMobileListingBottomBar && mapSizeWithMobileListingBottomBar)}>{children}</div>
    );
};

const mapSizeStyle = css({
    position: "relative",
    display: "flex",
    width: "100%",
    transition: "margin-right 500ms",
    transitionDelay: "50ms",

    md: {
        mr: 0
    }
});

const mapSizeWitchSidebar = css({
    md: {
        mr: "42%"
    }
});

const mapSizeWithMobileListingBottomBar = css({
    "& .leaflet-bottom .leaflet-control-zoom": {
        marginBottom: "calc(55px + var(--spacing-2) + env(safe-area-inset-bottom, 0px)) !important"
    },

    md: {
        "& .leaflet-bottom .leaflet-control-zoom": {
            marginBottom: "10px !important"
        }
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface Props {
    children: ReactNode;
    isSideBarOpen?: boolean;
    hasMobileListingBottomBar?: boolean;
}

export const MapSize = ({children, isSideBarOpen, hasMobileListingBottomBar}: Props) => {
    return (
        <div className={cx(mapSizeStyle, isSideBarOpen && mapSizeWitchSidebar, hasMobileListingBottomBar && mapSizeWithMobileListingBottomBar)}>{children}</div>
    );
};

const mapSizeStyle = css({
    position: "relative",
    display: "flex",
    width: "100%",
    transition: "margin-right 500ms",
    transitionDelay: "50ms",

    md: {
        mr: 0
    }
});

const mapSizeWitchSidebar = css({
    md: {
        mr: "42%"
    }
});

const mapSizeWithMobileListingBottomBar = css({
    "& .leaflet-bottom .leaflet-control-zoom": {
        marginBottom: "calc(55px + var(--spacing-2) + env(safe-area-inset-bottom, 0px)) !important"
    },

    md: {
        "& .leaflet-bottom .leaflet-control-zoom": {
            marginBottom: "10px !important"
        }
    }
});
